<template functional>
  <svg width="112" height="112" viewBox="0 0 112 112" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M68.1984 0.700195L21.5984 47.3002L3.19844 29.0002L0.398438 31.8002L21.5984 53.0002L24.3984 50.2002L71.0984 3.50019L68.1984 0.700195Z" fill="#1562AD" alignment-baseline="middle"/>
    <path d="M108 56C108 84.7 84.7 108 56 108C27.3 108 4 84.7 4 56C4 27.3 27.3 4 56 4C84.7 4 108 27.3 108 56ZM112 56C112 25.1 86.9 0 56 0C25.1 0 0 25.1 0 56C0 86.9 25.1 112 56 112C86.9 112 112 86.9 112 56Z" fill="#1562AD"/>
  </svg>
</template>
<script>
export default {
  name: 'SpinnerLarge'
};
</script>
<style lang="scss" scoped>
  svg path:nth-child(1) {
    transform: translate(20px, 32px);
  }
</style>
